const allowedIncomingMessages = {
  TYPES: {
    TEXT: "text",
    BUTTON: "button",
    DOCUMENT: "document",
    IMAGE: "image",
    INTERACTIVE_REPLY: "interactive",
  },
  MIME_TYPES: {
    PDF: "application/pdf",
    IMAGE_JPEG: "image/jpeg",
    IMAGE_PNG: "image/png",
  },
};

const endpoints = {
  EMAIL_SERVICE_ENDPOINT:
    "https://4elyea23mfngeb3czfojlfucgm0hfyum.lambda-url.eu-west-1.on.aws/",
};

const channels = {
  WHATSAPP: "WHATSAPP",
  WEB_CHAT: "WEB_CHAT",
};

const chatStages = {
  INITIAL: "Initial",
  CHOOSING_CATEGORY: "CHOOSING_CATEGORY",
  CHAT_OPENED: "CHAT_OPENED",
  CLOSED: "CLOSED",
  ARCHIVED: "ARCHIVED",
  BLOCKED: "BLOCKED",
};

const messageSender = {
  AGENT: "AGENT",
  CLIENT: "CLIENT",
};

const createGreetingMessage = () => {
  const salutation = "Good Day";
  return `*${salutation}!* I am WSU Assistant, your friendly online support. I am able to help you with the following options😊`;
};

const createInitialResponse = async (automatedResponsesQuerySnapshot) => {
  let automatedResultsList =
    "*Make a selection* from below by choosing and replying with number.\n\n";

  let lineNumber = 1;
  automatedResponsesQuerySnapshot.forEach((doc) => {
    automatedResultsList +=
      lineNumber + ". " + doc.data().Label + " " + doc.data().Emoji + "\n";
    lineNumber++;
  });

  automatedResultsList += lineNumber + ". Other/General 🔘";

  return automatedResultsList;
};

const messages = {
  GREETING: createGreetingMessage(),
  INVALID_CHOICE: "*Invalid response*. Please reply with the correct response.",
  REDIRECT_TO_QUEUE_MESSAGE:
    "*Dear user*, we are redirecting you to a Customer Agent. Please stay online as our dedicated agent will be with you shortly. Your patience is greatly appreciated.",
  OTHER: "Other/General",
  OTHER_ID_PREFIX: "Other_",
};

const typeOfService = {
  CHATS: "chats",
  CASES: "cases",
};

const whatsapp = {
  WHATSAPP_END_POINT:
    "https://graph.facebook.com/v16.0/103095676119616/messages",
  WHATSAPP_TOKEN:
    "EAAK72KTBR64BAAiMiup0N46NIoVF4ZB83tD7IogGsDrIxDqrDK0pV1EluQaQXGZBljeWSMcpJL8RKwDFOjAsrZCZA60pHXfylxZCodohjZANGvPMobMqsfftIDkK5AQc2DxiKP5LCcJGdWqksNjxblRVtTIeed43x9nblXnWZBrkH3vSSqENL2WZAEkN12wjlmFkvZBLXQeCO7lqfzVsleZANgnP3LdTU7ZBpUZD",
};

const sourceEmailList = {
  NO_REPLY: "noreply@servicedesk.myplusplus.com",
};

const priorities = {
  HIGH: {
    Label: "HIGH",
    Score: "",
  },
};

const caseStatuses = {
  OPEN: "OPEN",
};

const Constants = {
  caseStatuses,
  priorities,
  whatsapp: whatsapp,
  allowedIncomingMessages: allowedIncomingMessages,
  messages: messages,
  chatStages: chatStages,
  createInitialResponse: createInitialResponse,
  messageSender: messageSender,
  channels: channels,
  typeOfService: typeOfService,
  endpoints: endpoints,
  sourceEmailList,
};

export default Constants;
